import axios from 'axios';
import type { QueryKey } from 'react-query';

import { getApiHost } from '@hotjar/common';
import type { Site } from '@hotjar/site';

import { userResourcesDtoToModel } from './mapper';
import type { UserResources } from './model';
import type { UserResources as UserResourcesDTO } from './dto';

export async function getUserResources(userId: number): Promise<UserResources> {
  if (!userId) {
    throw new Error('UserId is mandatory');
  }

  const response = await axios.get<UserResourcesDTO>(
    `${getApiHost()}/api/v1/users/${userId}/resources`,
  );

  return userResourcesDtoToModel(response.data);
}

// /////////////////////////////////
// React-query parameters
// /////////////////////////////////

export const USER_RESOURCES_QUERY_KEY = 'userResources';

export const CURRENT_SITE_LOCAL_STORAGE_KEY: QueryKey = `currentSite`;

export const setCurrentSiteInLocalStorage = (data?: Site): void => {
  if (data) {
    localStorage.setItem(CURRENT_SITE_LOCAL_STORAGE_KEY, JSON.stringify(data));
  } else {
    localStorage.removeItem(CURRENT_SITE_LOCAL_STORAGE_KEY);
  }
};

export const getCurrentSiteFromLocalStorage = (): Site | undefined => {
  const jsonString = localStorage.getItem(CURRENT_SITE_LOCAL_STORAGE_KEY) ?? '';
  return jsonString ? JSON.parse(jsonString) : undefined;
};

export const USER_RESOURCES_QUERY_CONFIG = {
  staleTime: 60 * 60 * 1000,
  cacheTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
};
